import React from 'react';
import { css } from 'glamor';

import { ZINDEX_DEEPLINKS } from 'depop/styles/zIndex';

import { FormattedMessage } from 'react-intl';

import Cross from 'depop/components/icons/Cross';

import { WHITE, BLACK, RED } from 'depop/styles/colors';

const baseButtonStyle = {
  display: 'flex',
  transition: 'bottom 300ms cubic-bezier(0.25, 0.1, 0.18, 1.4) 2s',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  left: '50%',
  width: '10em',
  marginLeft: '-5em',
  color: 'white',
  backgroundColor: RED,
  border: '1px solid',
  borderColor: RED,
  borderRadius: '30px',
  userSelect: 'none',
  outline: 'none',
  zIndex: ZINDEX_DEEPLINKS,
  '@media (min-width: 701px)': {
    display: 'none',
  },
  'body.branch-banner-is-active &': {
    display: 'none'
  }
};

const bannerLinkStyle = {
  display: 'block',
  padding: '10px 0',
  fontSize: '14px',
  textAlign: 'center',
  textDecoration: 'none',
  color: 'inherit',
  outline: 'none',
};

const closeBtnStyle = {
  display: 'block',
  width: '12px',
  height: '14px',
  marginRight: '13px',
  outline: 'none',
};


export default class AppBanner extends React.Component {
  props: {
    link: String,
    path: String,
    open: Boolean,
    close: () => void,
  };

  render() {
    const { link, open, close, clickAction, channel } = this.props;
    const deeplinkPath = !!this.props.path;
    const showBtn = link && open && deeplinkPath;
    const href = `${link}?channel=${channel || 'app%20banner'}`;

    const buttonStyle = {
      ...baseButtonStyle,
      bottom: showBtn ? '20px' : '-140px'
    };

    return (
      <div {...css(buttonStyle)}>
        <a
          href="javascript:;"
          onClick={close}
          {...css(closeBtnStyle)}>
          <Cross fill="white" />
        </a>

        <a
         {...css(bannerLinkStyle)}
         onClick={clickAction}
         rel="noopener"
         href={href}>
         <FormattedMessage
           id="AppBanner.openApp"
           description="Call to action on app banner, MUST BE SMALL"
           defaultMessage="Open in app"
         />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/components/banners/AppBanner.js